import { action, createStore, thunk } from "easy-peasy";
import { AppError, AppStatus, StoreInjections, StoreModel } from "../types";
import { AppService } from "../lib/AppService";
import { buy } from "./wallet/buy";
import { connect } from "./wallet/connect";
import { init } from "./wallet/init";
import { mintFreeOne } from "./wallet/mintFreeOne";

export const storeModel: StoreModel = {
  wallet: undefined,
  mintedCount: 0,
  tokenPrice: undefined,
  setWallet: action((state, payload) => {
    state.wallet = payload;
  }),
  setMintedCount: action((state, payload) => {
    state.mintedCount = payload;
  }),
  setTokenPrice: action((state, payload) => {
    state.tokenPrice = payload;
  }),
  errors: [],
  setErrors: action((state, payload) => {
    state.errors = payload;
  }),
  status: AppStatus.Disconnected,
  setStatus: action((state, payload) => {
    state.status = payload;
  }),
  init: thunk(init),
  connect: thunk(connect),
  switchToPolygon: thunk(async (actions, payload, helpers) => {
    const app = helpers.injections.AppService;
    try {
      await (app as any).switchToPolygon();
    } catch (e) {
      return AppStatus.Disconnected;
    }
  }),
  disconnect: thunk(() => {}),
  buy: thunk(buy),
  mintFreeOne: thunk(mintFreeOne),
  mintRef: thunk(async (actions, payload, helpers) => {
    const app = helpers.injections.AppService;
    try {
      await app?.mintRef(payload.amount, payload.ref);
    } catch (e: any) {
      if (e.message === AppError.UserDeniedTransaction) {
        actions.setErrors([AppError.UserDeniedTransaction]);
      }
    }
  }),
};

export const store = createStore<StoreModel, {}, StoreInjections>(storeModel, {
  injections: {
    AppService: new AppService(),
  },
});
